import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExportService {

  constructor() { }

   exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {type: EXCEL_TYPE});
    FileSaver.saveAs(data, fileName + '_export_' + new  Date().getTime() + EXCEL_EXTENSION);
  }

  exportAsPDF(fileName, data, type, columns){
    const pdfName = `${fileName}.pdf`;
    const doc = new jsPDF();
    if (type === 'text') {
      doc.text(data, 10, 10);
    }
    else if (type === 'table') {
      const exportColumns = columns.map(col => ({title: col.name, dataKey: col.key}));
      doc.autoTable(exportColumns, data);
    } else {
      // todo
    }
    doc.save(pdfName);
  }

   exportCSV(columns, data, exportFilename, csvSeparator = ',') {
    let csv = '';

    // headers
    columns.forEach((column, i) => {
      if ( column.name) { // column.exportable !== false &&
        csv += '"' + (column.name) + '"';

        if (i < (columns.length - 1)) {
          csv += csvSeparator;
        }
      }
     });

    // body
    data.forEach((record, rowIndex) => {
      csv += '\n';
      columns.forEach((column, index) => {
        if ( column.name) { // column.exportable !== false &&
          let cellData = record[column.key];

          if (cellData != null) {
              cellData = String(cellData).replace(/"/g, '""');
          }
          else {
            cellData = '';
          }

          csv += '"' + cellData + '"';

          if (index < (columns.length - 1)) {
            csv += csvSeparator;
          }
        }
      });
    });

    const blob = new Blob([csv], {
      type: 'text/csv;charset=utf-8;'
    });

    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveOrOpenBlob(blob, exportFilename + '.csv');
    }
    else {
      const link = document.createElement('a');
      link.style.display = 'none';
      document.body.appendChild(link);
      if (link.download !== undefined) {
        link.setAttribute('href', URL.createObjectURL(blob));
        link.setAttribute('download', exportFilename + '.csv');
        link.click();
      }
      else {
        csv = 'data:text/csv;charset=utf-8,' + csv;
        window.open(encodeURI(csv));
      }
      document.body.removeChild(link);
    }
  }
}
